import { storage } from "@gtmhub/core/storage";
import dayjs from "@gtmhub/dayjs";
import { IKrUpdate, IReflection, ReflectionQuestion, IReflectionUpdate, IReflectionUpdateAnswer, ReflectionQuestionType } from "../models/reflections.models";

export const getMockedReflections = (params: { teamId: string }): IReflection[] => {
  const yesterday = dayjs.utc().subtract(1, "day").toISOString();

  return [
    {
      id: "1",
      accountId: storage.get("accountId"),
      teamId: params.teamId,
      templateId: "template1",
      questions: mockedQuestions(),
      createdAt: yesterday,
      updatedAt: "",
      schedule: {
        cadence: "wednesday",
        isPaused: false,
      },
      isEnabled: true,
    },
  ];
};

export const getMockedReflectionUpdates = (params: { teamId: string }): IReflectionUpdate[] => {
  const yesterday = dayjs.utc().subtract(1, "day").toISOString();

  return [
    {
      id: "update-1",
      reflectionId: "1",
      userId: storage.get("userId"),
      teamId: params.teamId,
      accountId: storage.get("accountId"),
      createdAt: yesterday,
      updatedAt: "",
      answers: mockedUpdateAnswers(),
    },
  ];
};

export const mockedQuestions: () => ReflectionQuestion<ReflectionQuestionType.textArea>[] = () => {
  const yesterday = dayjs.utc().subtract(1, "day").toISOString();

  return [
    {
      id: "question-1",
      text: "What are the important things you have done",
      type: ReflectionQuestionType.textArea,
      createdAt: yesterday,
      isEnabled: true,
      isDefault: false,
    },
    {
      id: "question-2",
      text: "What are your top priorities",
      type: ReflectionQuestionType.textArea,
      createdAt: yesterday,
      isEnabled: true,
      isDefault: false,
    },
    {
      id: "question-3",
      text: "What concerns should the team be aware of",
      type: ReflectionQuestionType.textArea,
      createdAt: yesterday,
      isEnabled: true,
      isDefault: false,
    },
    {
      id: "question-4",
      text: "Summary",
      type: ReflectionQuestionType.textArea,
      createdAt: yesterday,
      isEnabled: true,
      isDefault: true,
    },
  ];
};

export const mockedUpdateAnswers: () => IReflectionUpdateAnswer[] = () => {
  const yesterday = dayjs.utc().subtract(1, "day").toISOString();

  return [
    {
      id: "asnwer-1",
      questionId: mockedQuestions()[0].id,
      question: mockedQuestions()[0].text,
      answer: "This is the answer",
      createdAt: yesterday,
      updatedAt: "",
    },
  ];
};

export const krUpdates: IKrUpdate[] = [
  {
    title: "250 UX bugs are handled 2",
    confidence: 0.2,
    value: 0.3,
    comment:
      "Connectivity is now a commodity. As an organisation that once was a one-stop-shop for connectivity and content we’re now viewed as a “dumb pipe.” How might we might increase the value of our service.",
  },
  {
    title: "250 UX bugs are handled 3",
    confidence: 0.4,
    value: 0.5,
    comment: "We managed to fix just a few of UX bugs",
  },
  {
    title: "Hire top talent",
    confidence: 0.6,
    value: 0.7,
    comment: "We need to work on this more",
  },
  {
    title: "Achieve product Zen",
    confidence: 0.8,
    value: 1,
    comment: "Absolutely smashed it.",
  },
];

export const getMockedKrUpdates = (): IKrUpdate[] => {
  return krUpdates;
};
